import sliceCreator from '../../index.js';
import {GET_ADMIN_REPORT} from '../../../constants/index.js';
const _getAdminDamageReportAction = sliceCreator('GET_ADMIN_REPORT',GET_ADMIN_REPORT, 'get');

const { asyncAction: getAdminDamageReportAction, reducer, clearData: clearGetAdminDamageReportAction } = _getAdminDamageReportAction;

export default reducer;

export {
    getAdminDamageReportAction,
    clearGetAdminDamageReportAction
}


